/* Pure string helpers shared across the UI. */

export function escapeHtml(value) {
  return String(value).replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]
  );
}

/**
 * A hash-route `href` built from dynamic id segments — e.g.
 * `hashHref('/topic/{}', id)` → `#/topic/abc`.
 *
 * `encodeURIComponent` per segment is what makes this correct: an id carrying a
 * `/`, `?` or `#` would otherwise break out of its route segment and the router
 * would match something else. The call sites were split between doing that and
 * merely HTML-escaping, which guards the attribute but not the route.
 *
 * Percent-encoding happens to leave nothing for `escapeHtml` to do (it already
 * encodes `& < > " '`), so the result is equally safe interpolated into a template
 * string or handed to `setAttribute`.
 *
 * @param {string} path Route with `{}` placeholders filled in by `segments`.
 * @param {...string} segments Dynamic id values, in the order they appear.
 */
export function hashHref(path, ...segments) {
  let index = 0;
  return `#${path.replace(/\{\}/g, () => encodeURIComponent(segments[index++] ?? ''))}`;
}
